import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import PDFViewer from '../containers/Onboarding/PDFViewer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const styles = theme => ({
    container: {
        width: '100%',
        // display: 'flex',
        // flexWrap: 'wrap',
        display: 'table-cell',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    root: {
        marginLeft: theme.spacing.unit,
        marginBottom: '6px',
        width: '100%',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '300px',
      },
      button: {
        //margin: theme.spacing.unit,
      },
    card: {
        minWidth: 250,
        width: 400,
        height: 200,
        marginRight: 6,
        marginBottom: 6,
    
    },
    table: {
        width: '100%',
    },
    link: {
        textDecoration: 'none',
      },
    header:{
            fontSize: 13,
    },
    row:{
        fontSize: 12
    },
});

class UploadedDoc extends Component  {
    constructor(props) {
        super(props);
    }
    state = {
        file: null,
        doc_name: null,
        open:false,
        fileUrl: ''
    }

    handleClickOpen = (fileUrl) => {
        console.log('UPPfileUrl', fileUrl);
        this.setState({ open: true, fileUrl: fileUrl });
    };

    handleClose = (value) => {
        this.setState({ open: false, fileUrl: '' });
    };

    uploadFile = (event) => {

    }
    
    handleReset = (event, filename) => {
        
    }
    
    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    getDisplayFileName = (name) => {
        var parts = (''+name).split('.');
        var fileFormat = '.' + parts.pop();
        var baseFileName = parts.join('.'); 
        baseFileName = baseFileName.split('##__##')[0];
        var file_name = baseFileName + fileFormat;
        return file_name;
    }

    render(){
        const { classes, rows } = this.props;
        return (
            <div className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                    <TableRow style={{height: 16}}>
                        <TableCell className={classes.header} style={{width: '50px'}}></TableCell>
                        <TableCell className={classes.header} align="left" style={{width: '30%'}}></TableCell>
                        <TableCell className={classes.header} align="left" style={{width: 'auto'}}>{this.context.t('File')}</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows && rows.map((row, index) => (
                                <TableRow key={index} hover style={{height: 16}}>
                                    <TableCell className={classes.row} component="th" scope="row" style={{width: '50px'}}>
                                        {index+1}
                                    </TableCell>
                                    <TableCell className={classes.row} align="left" style={{width: '30%'}}>
                                        {row.doc_name}
                                    </TableCell>
                                    <TableCell className={classes.row} align="left" style={{width: 'auto'}}>

                                        {(''+row.filename).includes('pdf') &&
                                        <span onClick={() => this.handleClickOpen('https://www.hkarbsoc.org.hk:9000/getUploadedDoc/?id=' + encodeURIComponent(row.filename))}
                                            className={classes.link}>
                                            <a>{this.getDisplayFileName(row.filename)}</a>
                                        </span>}

                                        {(!(''+row.filename).includes('pdf')) &&
                                        <a  target='_blank'
                                            href={'https://www.hkarbsoc.org.hk:9000/getUploadedDoc/?id=' + encodeURIComponent(row.filename)}
                                            className={classes.link}
                                        >
                                            {this.getDisplayFileName(row.filename)}
                                        </a>}
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
                <Dialog
                    fullScreen
                    maxWidth= 'lg'
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                    <Button 
                        onClick={() => this.handleClose()} 
                        color="primary" 
                        style={{ fontSize: 12 }}
                        autoFocus>
                        {this.context.t('Close')}
                    </Button>
                    <PDFViewer isDesktop={this.props.isDesktop} file={this.state.fileUrl} fileURLNoName={this.state.fileUrl} />
                </Dialog>
            </div>
        );
    }
}

UploadedDoc.contextTypes = {
    t: PropTypes.func
  }

export default withStyles(styles)(UploadedDoc);